import { IOptionsWithTypes } from "@eventr/common";
import { useCallback, useMemo } from "react";
import { bs, useBoundStore } from "state/bound.store";
import { useViewedUserId } from "feat/viewedUser/viewedUser";

/** Matches tags and users against whoever is on screen: the viewed member, or yourself. */
export const useMatchTagsAndUsers = () => {
  const wpUser = useBoundStore((s) => s.wpUser);
  const viewedUserId = useViewedUserId();

  const subjectUser = useMemo(() => {
    return viewedUserId !== null ? bs().getUserFromID(viewedUserId) : wpUser;
  }, [wpUser, viewedUserId]);

  const matchTagsAndUser = useCallback(
    (tagOrUser: IOptionsWithTypes) => {
      if (tagOrUser === undefined) return false;
      switch (tagOrUser.type) {
        case "User":
          return tagOrUser.option === subjectUser?.id;
        case "Department":
          return subjectUser?.departmentTags?.includes(tagOrUser.option as string);
        case "Group":
          return subjectUser?.groupTags?.includes(tagOrUser.option as string);
        default:
          return false;
      }
    },
    [subjectUser],
  );
  return { matchTagsAndUser, subjectUser };
};
